/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import { GroupSessionModel } from '../../models/group-session-model';

export interface GetGroupSession$Params {
  groupSessionID: number;
}

export function GetGroupSession(
  http: HttpClient,
  rootUrl: string,
  params: GetGroupSession$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<GroupSessionModel>> {
  const rb = new RequestBuilder(rootUrl, GetGroupSession.PATH, 'get');
  rb.query('groupSessionID', params.groupSessionID, {});
  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    )
    .pipe(
      filter((response: any): response is HttpResponse<any> =>
        response instanceof HttpResponse
      ),
      map(
        (response: HttpResponse<any>) =>
          response as StrictHttpResponse<GroupSessionModel>
      )
    );
}

GetGroupSession.PATH = '/api/Staff/GetGroupSession';
